import { render } from "./DateColumn.vue?vue&type=template&id=28ded2e7&scoped=true"
import script from "./DateColumn.vue?vue&type=script&lang=js"
export * from "./DateColumn.vue?vue&type=script&lang=js"

import "./DateColumn.vue?vue&type=style&index=0&id=28ded2e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ded2e7"]])

export default __exports__